/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePageIssuesConfigurationMutationVariables = GraphQL.Exact<{
  issueCategoryName: GraphQL.Scalars['String']['input'];
  issueCategoryConfiguration: GraphQL.Scalars['Array']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UpdatePageIssuesConfigurationMutation = { readonly __typename?: 'Mutation', readonly UpdatePageIssuesConfiguration: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly scopeIssues: ReadonlyArray<{ readonly __typename?: 'WebsiteScopeIssues', readonly name: string, readonly health: number, readonly issueCategories: ReadonlyArray<{ readonly __typename?: 'WebsiteIssueCategory', readonly configuration: Record<string, any>, readonly defaultConfiguration: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueCategoryState, readonly affectedPagesPerState: { readonly __typename?: 'WebsiteIssueAffectedPagesPerState', readonly absoluteNumberOfPages: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStateAbsoluteNumberOfPages', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number }, readonly percentage: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStatePercentage', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number } } | null, readonly issues: ReadonlyArray<{ readonly __typename?: 'WebsiteIssue', readonly configuration: Record<string, any>, readonly context: any | null, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly isPresentable: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueState, readonly affectedPagesPerState: { readonly __typename?: 'WebsiteIssueAffectedPagesPerState', readonly absoluteNumberOfPages: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStateAbsoluteNumberOfPages', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number }, readonly percentage: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStatePercentage', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number } } | null, readonly ignoringRuleOnCases: { readonly __typename?: 'PageIssueIgnoringRuleOnCases', readonly id: CK.ID, readonly ignoredCases: ReadonlyArray<any>, readonly isEffective: boolean } | null, readonly ignoringRuleOnPages: { readonly __typename?: 'PageIssueIgnoringRuleOnPages', readonly id: CK.ID, readonly ignoredPageLegacyIds: ReadonlyArray<number>, readonly isEffective: boolean } | null, readonly ignoringRuleOnSegments: { readonly __typename?: 'PageIssueIgnoringRuleOnSegments', readonly id: CK.ID, readonly ignoredSegments: ReadonlyArray<string>, readonly isEffective: boolean } | null, readonly ignoringRuleOnWebsite: { readonly __typename?: 'IssueIgnoringRuleOnWebsite', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean } }> }> }> } | null } } };


export const UpdatePageIssuesConfigurationDocument = gql`
    mutation UpdatePageIssuesConfiguration($issueCategoryName: String!, $issueCategoryConfiguration: Array!, $websiteId: WebsiteId!) {
  UpdatePageIssuesConfiguration(
    issueCategory: $issueCategoryName
    issueCategoryConfiguration: $issueCategoryConfiguration
    websiteId: $websiteId
  ) {
    query {
      website(id: $websiteId) {
        id
        scopeIssues {
          issueCategories {
            affectedPagesPerState {
              absoluteNumberOfPages {
                closed
                ignored
                notApplicable
                notRequired
                open
                unknown
              }
              percentage {
                closed
                ignored
                notApplicable
                notRequired
                open
                unknown
              }
            }
            configuration
            defaultConfiguration
            isActionable
            isConfigurationModified
            isIgnored
            issues {
              affectedPagesPerState {
                absoluteNumberOfPages {
                  closed
                  ignored
                  notApplicable
                  notRequired
                  open
                  unknown
                }
                percentage {
                  closed
                  ignored
                  notApplicable
                  notRequired
                  open
                  unknown
                }
              }
              configuration
              context
              ignoringRuleOnCases {
                id
                ignoredCases
                isEffective
              }
              ignoringRuleOnPages {
                id
                ignoredPageLegacyIds
                isEffective
              }
              ignoringRuleOnSegments {
                id
                ignoredSegments
                isEffective
              }
              ignoringRuleOnWebsite {
                id
                isActive
                isEffective
              }
              isActionable
              isConfigurationModified
              isIgnored
              isPresentable
              name
              pointsGained
              pointsToGain
              state
            }
            name
            pointsGained
            pointsToGain
            state
          }
          name
          health
        }
      }
    }
  }
}
    `;
export type UpdatePageIssuesConfigurationMutationFn = Apollo.MutationFunction<UpdatePageIssuesConfigurationMutation, UpdatePageIssuesConfigurationMutationVariables>;

/**
 * __useUpdatePageIssuesConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdatePageIssuesConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageIssuesConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageIssuesConfigurationMutation, { data, loading, error }] = useUpdatePageIssuesConfigurationMutation({
 *   variables: {
 *      issueCategoryName: // value for 'issueCategoryName'
 *      issueCategoryConfiguration: // value for 'issueCategoryConfiguration'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUpdatePageIssuesConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageIssuesConfigurationMutation, UpdatePageIssuesConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageIssuesConfigurationMutation, UpdatePageIssuesConfigurationMutationVariables>(UpdatePageIssuesConfigurationDocument, options);
      }
export type UpdatePageIssuesConfigurationMutationHookResult = ReturnType<typeof useUpdatePageIssuesConfigurationMutation>;
export type UpdatePageIssuesConfigurationMutationResult = Apollo.MutationResult<UpdatePageIssuesConfigurationMutation>;
export type UpdatePageIssuesConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdatePageIssuesConfigurationMutation, UpdatePageIssuesConfigurationMutationVariables>;